import {Layout, Menu} from "antd";

import {Menu as Header} from "../Menu/Menu.jsx";
import styles from "./MenuLayout.module.css";
import {Outlet, useLocation, useNavigate} from "react-router-dom";

export const MenuLayout = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const selected = location.pathname.split("/")[2];

	const menuItems = [
		{
			key: "user-preferences",
			label: "User Preferences",
			onClick: () => navigate("/settings/user-preferences"),
		},
	];

	return (
		<Layout className={styles.mainWrapper}>
			<Header />
			<Layout className={styles.body}>
				<Layout.Sider width={"20%"} theme="light">
					<Menu theme="light" mode="inline" selectedKeys={[selected]} items={menuItems} />
				</Layout.Sider>

				<Layout.Content className={styles.content}>
					<Outlet />
				</Layout.Content>
			</Layout>
		</Layout>
	);
};
